import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from "../../common/loadingComponent";
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { searchActions, cuzkExpandType } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import BbPopover from '../../common/popover';
import Message from '../../common/message';
import PropertyCzOwnershipDocumentDetail from './propertyCzOwnershipDocumentDetail';
import PropTypes from 'prop-types';

import SvgOdemcene from '../../../img/icons/Odemcene';
import SvgZamcene from '../../../img/icons/Zamcene';
import SvgRefresh from "../../../img/icons/Refresh";

import './propertyCz.scss';

class PropertyCzOwnershipDocument extends React.Component {
    state = {
        expanded: false,
        alreadyExpanded: false
    };

    static propTypes = {
        data: PropTypes.object.isRequired,
        showRestrictions: PropTypes.bool.isRequired
    };

    static defaultProps = {
        fromSearch: false
    }

    componentDidMount() {
        if (this.props.fromSearch)
            this.setState({ expanded: true, alreadyExpanded: true })
    }

    render() {
        const data = this.props.data;
        const hasRestrictions = this.props.showRestrictions;

        return (
            <>
                <tr>
                    <td>
                        <span className='detail-link'>
                            <a className="link-internal" onClick={_ => this.expandRow(data)}>
                                {!data.isPurchased && !this.state.alreadyExpanded && <SvgZamcene />}
                                <Translate id='Report.Detail' />
                            </a>
                        </span>
                    </td>
                    <td>{data.ownershipDocumentId}</td>
                    <td>{data.share}</td>
                    <td>{data.owners.length > 0 ? data.owners.length : ""}</td>
                    <td>{data.ownerName}</td>
                    {hasRestrictions && <td></td>}
                </tr>
                <tr style={{ display: this.state.expanded ? "" : "none", background: "none" }}>
                    <td colSpan={hasRestrictions ? 6 : 5} style={{ paddingLeft: '2em', paddingTop: '1em' }}>
                        {this.renderDocumentContent(data)}
                    </td>
                </tr>
            </>
        )
    }

    renderDocumentContent = (data) => {
        if (!this.props.fromSearch) {
            if (isNullOrUndefined(this.props.search.detail[data.telId]))
                return null;

            if (isNullOrUndefined(this.props.search.detail[data.telId].data) && isNullOrUndefined(this.props.search.detail[data.telId].error))
                return <Circles />;

            if (isNullOrUndefined(this.props.search.detail[data.telId].data) && !isNullOrUndefined(this.props.search.detail[data.telId].error))
                return <Message type="error" message={this.props.translate("PropertyCz.Error")} />;

            const dataException = this.props.search.detail[data.telId].data.exception;
            if (!isNullOrUndefined(dataException)) {
                const dataExceptionParams = this.props.search.detail[data.telId].data.exceptionData;
                const dataExceptionLevel = this.props.search.detail[data.telId].data.exceptionLevel;
                return <Message type={dataExceptionLevel || "error"} options={{ renderInnerHtml: true }}
                    message={this.props.translate(dataException, isNullOrUndefined(dataExceptionParams) ? undefined : dataExceptionParams)} />;
            }
        }

        return <>
            <div className="cuzk-available" style={{ marginBottom: "1em" }}>
                {this.showUpdateData() && <div className="cuzk-column">
                    <BbPopover
                        content={this.props.translate("PropertyCz.Report.OD.UpdateDataPopover")}
                        placement="top"
                        targetId={`cuzk-available-od-${data.ownershipDocumentId}-link`}
                        toggleOnEvent="toggleOnMouse"
                    >
                        <div id={`cuzk-available-od-${data.ownershipDocumentId}-link`}>
                            <SvgRefresh className="refresh-icon" />
                            <div style={{ justifyContent: "flex-start" }} className="link-internal" onClick={() => this.updateData(data)}>
                                <Translate id="PropertyCz.Report.OD.UpdateData" /><SvgZamcene />
                            </div>
                        </div>
                    </BbPopover>
                </div>}
                <div className="cuzk-column" style={{ justifyContent: "flex-end" }}>
                    <span className="bold"><Translate id="PropertyCz.Completed" />: {this.props.fromSearch ? data.completedFormatted : (this.props.search.detail[data.telId].data).completedFormatted}</span>
                </div>
            </div>
            <PropertyCzOwnershipDocumentDetail telId={data.telId} data={this.props.fromSearch ? data : this.props.search.detail[data.telId].data} />
        </>
    }

    expandRow = (data) => {
        if (this.state.alreadyExpanded)
            this.setState({ expanded: !this.state.expanded }, () => this.props.cuzkExpand(cuzkExpandType.ownershipDocuments, this.props.cadastreUnitId, data.telId, null, this.state.expanded));
        else {
            this.setState({ expanded: true, alreadyExpanded: true }, () => this.props.cuzkExpand(cuzkExpandType.ownershipDocuments, this.props.cadastreUnitId, data.telId, null, this.state.expanded))
            this.props.cuzkSearchOwnershipDetail({ telId: data.telId, ownershipDocumentId: data.ownershipDocumentId, osId: this.props.osId, dataDate: this.getDataDate() });
        }
    }

    updateData = (data) => {
        if (this.props.fromSearch) {
            const p = this.props.search.report.data;

            if (p.id) {
                this.props.cuzkUpdateOwnershipDeedSearch({ cadastreUnitId: p.cadastreUnitId.toString(), ownershipDeedNo: p.ownershipDeedNo, dataDate: p.dataDate },
                    (id) => this.props.history.push(`/search/property-cz/report-ownership-deed?id=${id}`));
            } 
            else {
                this.props.cuzkUpdateOwnershipDetailAsReport(this.props.search.report.params)
            }
        }
        else {
            this.props.cuzkUpdateOwnershipDetailData({ telId: data.telId, ownershipDocumentId: data.ownershipDocumentId, osId: this.props.osId, dataDate: this.getDataDate() });
        }
    }

    showUpdateData = () => {
        if (this.props.fromSearch) {
            const p = this.props.search.report.data;
            return isNullOrUndefined(p.id ? p.dataDate: this.getDataDate());
        }
        else
            return isNullOrUndefined(this.getDataDate());
    }

    getDataDate = () => {
        try {
            return this.props.search.report.params.dataDate;
        } catch {
            return undefined;
        }
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.cuzk } }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(PropertyCzOwnershipDocument)));
